import { Link } from '@atlassian/amkt-common';
import React from 'react';
import ExternalLink from '../ExternalLink';
/**
 * Used to optionally link text to a URL.
 * Renders the children wrapped within an anchor tag if `href` is non-null; else renders the children as is;
 */
const OptionalLink = props => {
  const {
    href,
    children,
    title,
    external,
    onClick,
    className
  } = props;
  if (!href) return children;
  if (external) {
    return /*#__PURE__*/React.createElement(ExternalLink, {
      href: href,
      title: title,
      onClick: onClick,
      className: className,
      "data-testid": props['data-testid']
    }, children);
  }
  return /*#__PURE__*/React.createElement(Link, {
    href: href,
    title: title,
    onClick: onClick,
    className: className,
    "data-testid": props['data-testid']
  }, children);
};
export default OptionalLink;